var createRefBasicModel = require('../baseRefModel').default;
var {BASEHOST_REPORT} = require("../../../../pub/config/baseHost");

function createModel() {
    var model = new Object();
    var base = createRefBasicModel();
    function Model(){}
    Model.prototype = base;
    var model = new Model();
    model.baseModel = base;
    /***** 以上为固定代码，勿动, baseModel内方法自动继承过来，可用base调用  *****/
    model.refConfig = {
    	refName:'菜品参照',
    	refType:'tree',
        refDetail:'基本的菜品参照-适宜用下拉展现'
    }

	model.getRefFields = function(){
		return {
            id:'id',
            code:'dishCode',
            name:'dishName'
		}
	};

	model.getClassData = function(callback){

		var _self = this;
	    var potData ;



        const url = BASEHOST_REPORT + "/listDish";
        var params = {
            type: 1
        };
        var potParams = {
            type: 2
        };

        if(this.getTreeCondition()){
            params = this.mergeJsonObject(params,this.getTreeCondition());
        }

        if(!this.getTreeCondition().dishTypeRelateIdList){
            base.ajax.postJson(url,potParams,function(data){
                potData = data;
                base.ajax.postJson(url,params,function(data){
                    if(potData&&potData.length>0){
                        for (var i=0; i < potData.length; i++) {
                            data.push( potData[i] );
                        }
                    }

                    callback(data);
                });
            });
        }else {
            var selectData = this.getTreeCondition().dishTypeRelateIdList;
            if (contains(selectData, "1")) {
                base.ajax.postJson(url, potParams, function (data) {
                    potData = data;
                    base.ajax.postJson(url,params,function(data){
                        if(potData&&potData.length>0){
                            for (var i=0; i < potData.length; i++) {
                                data.push( potData[i] );
                            }
                        }

                        callback(data);
                    });
                });
            }else{
                base.ajax.postJson(url,params,function(data){
                    callback(data);
                });
            }
        }
	};

    model.getOne = function(value, callback){
        const params ={
            dishId: value
        }

        const url = BASEHOST_REPORT + "/getDish";;
        base.ajax.getJson(url,params,function(data){
            callback(data.dishName);
        });
    }


    return model;
}

function contains(arr, obj) {
    var i = arr.length;
    while (i--) {
        if (arr[i] == obj) {
            return true;
        }
    }
    return false;
}

module.exports = createModel;



// WEBPACK FOOTER //
// ./src/pub/components/baseRef/model/dishReportModel.js